// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__TuVrt","root_admin":"Sidebar_root_admin__6FtuO"};